import { useEffect, useState } from "react";
import RepProductReportHeader from "./rep-product-report-header";
import RepProductReportTotal from "./rep-product-report-total";
import dayjs from "dayjs";
import { serverFetch } from "../../../server";
import { strDate2Server } from "../../../extensions/utils";
import { message } from "antd";
import { isMobile } from "../../../extensions/design";
import { ExcelDataProvider } from "../rep-excel-data-provider";
import { useLocalStorageFilter } from "@/extensions/use-local-storage-filter";

const employeeType = [
  { value: 0, label: "Всe сотрудники"},
  { value: 1, label: "По менеджерам"},
  { value: 2, label: "По исполнителям"},
  { value: 3, label: "По пользователям"}
];

const priceType = [
    { value: 0, label: "По цене справочника"},
    { value: 1, label: "По цене продаж"}
];

// Отчет о продаже услуг и товаров
// Содержит шапку и сводную таблицу, вызывает запрос получения сводного 
const RepProduct = () => {
  const [filters, setFilters] = useLocalStorageFilter(
    'repProductFilter',
    () => ({
      startDate: dayjs(),
      endDate: dayjs(),
      productIds: [],
      employeeType: employeeType[0].value,
      priceFilterType: priceType[1].value
    }),
    (parsed) => {
      const { startDate, endDate } = (() => {
        const savedDateEnd = parsed.endDate ? dayjs(parsed.endDate) : null;
        const defaultDateFrom = dayjs();
        const defaultDateEnd = dayjs();
        if (savedDateEnd && dayjs().endOf('day').diff(savedDateEnd, 'day') > 1) {
          return { startDate: defaultDateFrom, endDate: dayjs().endOf('day') };
        } else if (savedDateEnd && savedDateEnd.isBefore(dayjs(), 'day')) {
          return { startDate: parsed.startDate ? dayjs(parsed.startDate) : defaultDateFrom, endDate: dayjs().endOf('day') };
        }
        return { startDate: parsed.startDate ? dayjs(parsed.startDate) : defaultDateFrom, endDate: savedDateEnd || defaultDateEnd };
      })();
      return {
        startDate: startDate,
        endDate: endDate,
        productIds: parsed.productIds || [],
        employeeType: parsed.employeeType ?? employeeType[0].value,
        priceFilterType: parsed.priceFilterType ?? priceType[1].value
      };
    },
    (filters) => ({
      startDate: filters.startDate?.format('YYYY-MM-DD'),
      endDate: filters.endDate?.format('YYYY-MM-DD'),
      productIds: filters.productIds || [],
      employeeType: filters.employeeType,
      priceFilterType: filters.priceFilterType
    }),
  );

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const onFilterChange = (value) => {
    setFilters({...filters, ...value})}
    
  const [data, setData] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const getData = () => {
    setLoading(true);
    serverFetch("report/SaleProducts", {method: "GET", queryParams: {startDate: strDate2Server(filters.startDate), endDate: strDate2Server(filters.endDate), 
        priceFilterType: filters.priceFilterType, employeeType: filters.employeeType,
      ...(filters.productIds != null && { productIds: filters.productIds})}})
      .then(data => {
        setData(data);
        console.log(data)
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

    const getProducts = () => {
    setLoading(true);
    serverFetch("product", {method: "GET", queryParams: { vids: [0, 1] }})
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

  const onRefresh = () => {
    getData();
    setRefreshTrigger((prev) => prev + 1); 
  };

  useEffect(() => {
    getProducts();
    getData();
  }, []);

  useEffect(() => {
    if (isMobile) {
      getData();
    }
  }, [filters]);

  return (
    <ExcelDataProvider>
      <RepProductReportHeader filters={filters} onFilterChange={onFilterChange} priceType={priceType} employeeType={employeeType} products={products} onRefresh={onRefresh} loading={loading}/>
      <RepProductReportTotal filters={filters} loading={loading} data={data} refreshTrigger={refreshTrigger}/>
    </ExcelDataProvider>
  )
}

export default RepProduct;